<template>
  <div>
    <div class="pdfok" id="pdfok" v-if="pdfok"></div>
    <div id="printMe" style=" width: 21cm; margin: 0 auto;">
      <div class="innerPage">
        <div style="padding: 30px 60px;" v-for="stu in stuList" :key="stu.id">
          <div style="height:1060px">
            <div style="text-align: center; font-size: 25px; padding: 30px;">
              2025年江苏省艺术职业学校单独招生学生档案表
            </div>
            <table border="" cellspacing="" cellpadding="">
              <tr>
                <td style="width: 12%;">考生姓名</td>
                <td style="width: 10%;">{{stu.stu_name}}</td>
                <td style="width: 9%;">性别</td>
                <td style="width: 9%;">{{stu.gender==1?'男':'女'}}</td>
                <td style="width: 10%;">出生年月</td>
                <td style="width: 10%;">{{stu.birthday}}</td>
                <td style="width: 10%;">民族</td>
                <td style="width: 10%;">{{stu.minzu}}</td>
                <td style="width: 20%;" colspan="2" rowspan="3">
                  <div style="padding: 5px;">

                    <img :src="stu.pjson&&stu.pjson.dzzp?stu.pjson.dzzp+'?x-oss-process=image/resize,w_200':''"
                         style="width: 140px;">
                  </div>
                </td>
              </tr>
              <tr>
                <td>籍贯</td>
                <td colspan="3">{{stu.hkszd}}</td>
                <td>考生来源</td>
                <td colspan="3">
                  <span v-if="stu.pre_id==1">应届生（本年度6月份毕业）</span>
                  <span v-if="stu.pre_id==2">往届生（上一年度毕业生）</span>
                  <span v-if="stu.pre_id==3">在校生（初一年级）</span>
                  <span v-if="stu.pre_id==4">在校生（小学五年级）</span>

                </td>
              </tr>
              <tr>
                <td>毕业学校</td>
                <td colspan="4">
                  {{stu.graduate_schname}}
                </td>
                <td>户口性质</td>
                <td colspan="2">
                  {{stu.hkxz}}
                </td>
              </tr>
              <tr>
                <td>身份证号码</td>
                <td colspan="9">
                  {{stu.identity_card}}
                </td>

              </tr>
              <tr>
                <td>通讯地址<br />（邮寄）</td>
                <td colspan="9">
                  {{stu.jtzz}}
                </td>

              </tr>
              <tr>
                <td colspan="2">联系电话</td>
                <td colspan="8">{{stu.phone}}</td>

              </tr>
              <tr>
                <td colspan="10">提 前 单 招 考 试 成 绩</td>


              </tr>
              <tr>
                <td colspan="2">文化准考证号</td>
                <td>语文</td>
                <td>数学</td>
                <td>英语</td>
                <td>政治</td>
                <td colspan="2">专业总分</td>
                <td colspan="2">录取分</td>

              </tr>

              <tr>
                <td colspan="2">{{stu.exam_num}}</td>
                <td>{{stu.pjson?stu.pjson.yuwen:''}}</td>
                <td>{{stu.pjson?stu.pjson.shuxue:''}}</td>
                <td>{{stu.pjson?stu.pjson.yingyu:''}}</td>
                <td>{{stu.pjson?stu.pjson.zhengzhi:''}}</td>
                <td colspan="2">{{stu.pjson?stu.pjson.zy_total:''}}</td>
                <td colspan="2">{{stu.exam_score}}</td>

              </tr>
              <tr>
                <td colspan="2">录取学校</td>
                <td colspan="8">{{stu.platform}}</td>

              </tr>
              <tr>
                <td colspan="2">录取专业名称</td>
                <td colspan="8">{{stu.major_name}}-{{stu.major_type}}</td>

              </tr>
              <tr>
                <td colspan="2">录取方法</td>
                <td colspan="8">{{stu.ctype==1?'单招':'补录'}}</td>

              </tr>
            </table>
          </div>


          <div style="height:1060px;overflow: hidden;"
               v-if="stu.pjson.identity_card1||stu.pjson.score||stu.pjson.hkb">
            <div style="height:80px"></div>
            <div style="height:250px;overflow: hidden;" v-if="stu.pjson.identity_card1">
              <img :src="stu.pjson.identity_card1" style="height:100%" />

            </div>
            <div style="height:720px;overflow: hidden; background-size: contain ; background-repeat: no-repeat;" :style="{backgroundImage:'url('+stu.pjson.score+')'}" v-if="stu.pjson.score">

            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'export',
  components: {},
  data() {
    return {
      pdfok: false,
      show_dev: false,
      show_dev1: true,
      dataover222: true,
      printObj: {
        id: 'printMe',
        popTitle: '',
        extraHead: '<meta http-equiv="Content-Language" content="zh-cn"/>'
      },
      userid: '',

      stuInfo: {},
      yuebao: [{}],
      zhoubao: [{}],
      chinaCitys: [],
      // 填入导出的pdf文件名和html元素
      pdfTitle: '试卷1',
      pdfSelector: '#printMe',
      stuList: [],
    }
  },
  mounted() {
    let id = this.getParams('id')
    let pmid = this.getParams('pmid')
    let pici = this.getParams('pici')
    let status = this.getParams('status')
    let year = this.getParams('year')
    this.getDataList(id, pmid,pici,status,year)

  },
  methods: {
    getDataList(id, pmid,pici,status,year) {
      let _this = this
      this.$http.post('http://zsapi.aiwx.org.cn/api/wltStuListToPdf', {
        id: parseInt(id) ? parseInt(id) : id,
        pmid: parseInt(pmid),
        pici_wlt: pici,
        status: status,
        year: year,
      }).then(res => {
        if (res.data) {
          res.data.forEach(item => {
            if (item.pjson && typeof (item.pjson) == "string") {
              item.pjson = JSON.parse(item.pjson)
            }
          })
          this.stuList = res.data;
        }

        this.$nextTick(() => {
          setTimeout(() => {
            _this.pdfok = true
          }, 500)
        })

      })

    },
    getParams(name) {
      let n_url = window.location.href
      n_url = n_url.replace('/#', '')
      if (n_url.indexOf('?') > 0) {
        n_url = n_url.split('?')[1]
      }
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = n_url.match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
  }
}
</script>
<style lang="less" type="text/less">
@import "/public/css/pdf_default";
</style>
<style scoped>
table,
table tr th,
table tr td {
  border: 1px solid #000;
  padding: 10px 0;
}

table {
  width: 100%;
  min-height: 25px;
  line-height: 25px;
  text-align: center;
  border-collapse: collapse;
  padding: 2px;
}
</style>
